/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SavedQuery {
  /**
  * The unique identifier of the saved query
  */
  'id': string;
  /**
  * The name of the saved query
  */
  'name': string;
  /**
  * A description of the saved query
  */
  'description'?: string | null;
  /**
  * The SQL query text
  */
  'query': string;
  /**
  * Tags for categorizing the saved query
  */
  'tags': Array<string>;
  /**
  * The timestamp when the saved query was created
  */
  'createdAt': Date;
  /**
  * The timestamp when the saved query was last updated
  */
  'updatedAt'?: Date | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "updatedAt",
      "baseName": "updatedAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return SavedQuery.attributeTypeMap;
  }

  public constructor() {
  }
}

